import styled, { css } from 'styled-components';
export const CTARow = styled.div `
  ${({ flexDirection = 'row', justifyContent = 'start', alignContent = 'center', }) => css `
    align-content: ${alignContent};
    align-items: center;
    display: flex;
    flex-direction: ${flexDirection};
    flex-wrap: wrap;
    grid-area: footer;
    grid-gap: 1rem;
    justify-content: ${justifyContent};
  `}
`;
